<div #baFullCalendar class="ba-full-calendar {{baFullCalendarClass || ''}}"></div>
